import React, { Component } from 'react'
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'
import get from 'lodash.get'
import Styled from 'styled-components'

import Navigation from 'components/Navigation'
import Content from 'components/Content'
import Identity from 'components/Identity'

const NavigationExtended = Styled(Navigation)``

const ContentExtended = Styled(Content)`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 100%;
`

const IdentityContainer = Styled.div``

class AppNavigation extends Component {
  render() {
    return (
      <NavigationExtended>
        <ContentExtended>
          <div />

          <IdentityContainer>
            <Identity />
          </IdentityContainer>
        </ContentExtended>
      </NavigationExtended>
    )
  }
}


const query = graphql(gql`
  query AppNavigation {
    viewer {
      user {
        _id
        displayName
      }
    }
  }
  `, {
    options() {
      return {
        fetchPolicy: 'network-only'
      }
    },
    props({ data }) {
      return {
        loading: get(data, 'loading')
      }
    }
  }
)

export default compose(
  query
)(AppNavigation)



// WEBPACK FOOTER //
// ./src/components/AppNavigation/index.js